<template>
  <div class="certificateList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="searchTitle" placeholder="请输入证书名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchNum" placeholder="请输入证书编号"></el-input>
        </el-form-item>
          <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_wj_addNews')}}</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight655 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="proprietorNotificationListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="a_title2" label="名称"></el-table-column>
        <el-table-column prop="bianhao" label="编号"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <viewer :images="scope.row.a_pic.split(',')" class="img-width">
              <img  :src="scope.row.a_pic" class="img">
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.a_id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:certificateList
   *@Description:证书列表
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    // name: '/manage/main.certificateList',
    data() {
      return {
        multipleSelection: [], // 多选框
        tableData: [], // 产品list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        searchTitle: '', // 证书名称查询条件
        searchNum: '', // 证书编号查询条件
        proprietorNotificationListbox: require('@/config/enum').proprietorNotificationListbox // 是否隐藏复选框
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('yhgCertificate', '')
      }, 200)
      this.getData()
    },
    activated() {
      // this.getData()
    },
    methods: {
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(`/nZhengshu?pageNo=${this.pageNo}&pageSize=${this.pageSize}&a_title2=${this.searchTitle}&bianhao=${this.searchNum}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增
      add() {
        window.localStorage.setItem('yhgCertificate1', '')
        this.$router.push({
          name: 'certificateAdd',
          query: {
            flag: false
          }
        })
      },
      // 编辑
      edit(rowData) {
        window.localStorage.setItem('yhgCertificate1', '')
        this.$router.push({
          name: 'certificateAdd',
          query: {
            flag: true,
            object: rowData
          }
        })
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/nZhengshu/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .certificateList {
    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }

    .img {
      width: 80px;
      height: 50px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
    }
  }
</style>